// extracted by mini-css-extract-plugin
module.exports = {"asterisk":"asterisk_asterisk__3NfNO"};